import classes from './errCard.scss';


const ErrCard = (props) => {
  let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  let RefreshImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Refresh.svg';
  return (

    <div className={classes.errorBanner}>
    <div class="row">
    <div class="col-xs-12">
    <div className={classes.errorMessageContainer}>
        <div className={classes.errorMessage}>
          <p className={classes.errorImage}><img src={warningImg} alt="Warning Image" /></p>
      
            <div className={classes.group2}>
                <div className={classes.notificationLabel}>
                <span>{props.errorMsge}</span>
                </div>
            <div className={classes.somethingWrong}>

            <button className={classes.refreshBtn} onClick={props.refresh} >Refresh <img src={RefreshImg} alt="Refresh Image" /></button>
            </div>
            </div>
        
        </div>
        
      </div>
    </div>
    </div>
    <br />
    
    </div>
  );
};

export default ErrCard;
